export function formatSeconds(total) {
  const seconds = Math.max(0, Math.floor(total || 0));
  const minutes = Math.floor(seconds / 60);

  return `${String(minutes).padStart(2, '0')}:${String(seconds % 60).padStart(
    2,
    '0'
  )}`;
}
